import { IPdfGridData } from '../common/make-pdf/v2/pdf-data.type';

export const getMajorCategoryName = (gridData: IPdfGridData): string =>
  gridData?.major_category_name ?? gridData?.majorCategory ?? '';

export const getMinorCategoryName = (gridData: IPdfGridData): string =>
  gridData?.minor_category_name ?? gridData?.minorCategory ?? '';
